import {isNil} from '@megaphonenpm/mputils/src/utils.js';
import {MULTICHOICE_PRODUCTS, RATING_PRODUCTS, PRODUCTNAME_UGC, TITLE_PRODUCTS} from './constants.js';

/**
 * Utilities for working with Product objects.
 */
export class ProductService {
  constructor () {
  }

  /**
   * Returns true if the specified productName is one of the official family of "multichoice products" (i.e., scenes
   * with multiple choice questions, such as Reader's Choice and Pic Pick). For the full list of official "multichoice products",
   * see MULTICHOICE_PRODUCTS. Note: to allow designers to use human-readable names in themes when specifying content visibility,
   * isMultichoiceProduct() intentionally uses product field-names rather than product IDs.
   *
   * @param productName A human-readable product field-name, such as "FiveStars" or "ReadersChoice" (case is ignored in the comparison).
   * @returns {boolean}
   */
  isMultichoiceProduct (productName) {
    return isNil(productName) ? false : MULTICHOICE_PRODUCTS.includes(productName.toLowerCase());
  }

  /**
   * Returns true if the specified productName is one of the official family of "rating products". For the full list of
   * official "rating products", see RATING_PRODUCTS.
   *
   * @param productName A human-readable product field-name, such as "FiveStars" or "GuessGauge" (case is ignored in the comparison).
   * @returns {boolean}
   */
  isRatingProduct (productName) {
    return isNil(productName) ? false : RATING_PRODUCTS.includes(productName.toLowerCase());
  }

  /**
   * Returns true if the specified productName is one of the official family of "title products". For the full list of
   * official "title products", see TITLE_PRODUCTS.
   *
   * @param productName A human-readable product field-name, such as "Bulletin" or "Teaser" (case is ignored in the comparison).
   * @returns {boolean}
   */
  isTitleProduct (productName) {
    return isNil(productName) ? false : TITLE_PRODUCTS.includes(productName.toLowerCase());
  }

  /**
   * Returns true if the specified productName is one of the official family of "social products". For now, a product is
   * considered a social product if its name ends with "to TV" (as in "Tweet to TV").
   *
   * @param productName A human-readable product field-name, such as "TweetToTV" (case is ignored in the comparison).
   * @returns {boolean}
   */
  isSocialProduct (productName) {
    return isNil(productName) ? false : productName.toLowerCase().endsWith('totv') || productName.toLowerCase() === PRODUCTNAME_UGC;
  }

}
